import $ from 'jquery';

// Inspiration popup
// ******************************
//

function changeUrl(data) {
	let url = `/${data.id}/${data.slug}`;
	window.location.hash = url;
}



function formatData(data) {
    return {
        title: data.modalTitle,
        type: data.modalLinkType,
        image: data.modalImage,
        description: data.modalDescription,
        id: data.modalId,
        slug: data.modalSlug,
        url: data.inspUrl
    }
}



function buildPopup(htmlData, isAjax) {
	let data;
	if (isAjax) {
		data = htmlData;
	} else {
	    data = formatData(htmlData);
	    changeUrl(data);
	}
    const popup = $('#inspModal');
    // popup image
    popup.find('img').attr('src', data.image);
    // popup title
    popup.find('h4').text(data.title);
    //popup description
    popup.find('p').text(data.description);

    let fbLink = `https://www.facebook.com/sharer/sharer.php?u=${data.url}`;
    let twitLink = `https://twitter.com/home?status=${data.url}`;
    let pinLink = `https://pinterest.com/pin/create/button/?url=${data.url}&media=${data.image}&description=`;
    popup.find('.socialLinkFB').attr('href', fbLink);
    popup.find('.socialLinkTwit').attr('href', twitLink);
    popup.find('.socialLinkPin').attr('href', pinLink);
}



function openPopup(target) {
    target.magnificPopup({
        items: {
            src: '#inspModal',
            type: 'inline',
            midClick: true,
            removalDelay: 300,
            mainClass: 'mfp-fade'
        }
    }).magnificPopup('open');
}



function initPopup(isAjax, _this) {
    if (isAjax) {
    	const data = _this;
    	buildPopup(data, isAjax);
	    openPopup($('#inspModal'));
    } else {
	    const data = _this.find('.inspiredItem').data();
	    buildPopup(data, isAjax);
	    openPopup(_this);
    }
}



function ajaxInsp(inspId) {
	const url = `/api/v1/inspirations/${inspId}.json`;
	$.get(url, function(data) {
		const actualData = data.data[0];
		initPopup(true, actualData);
	});
}


function attachHandlers() {
	$('#inspirationLanding').on('click', '.insp-image-open-modal', function(e) {
	    e.preventDefault();
	    initPopup(false, $(this));
	});
	if (window.location.pathname.includes('homeowners/inspiration') && window.location.hash) {
		const url = window.location.hash.split('/');
	    const inspId = url[1];
	    ajaxInsp(inspId);
	    // Because the original close button doesn't work when the popup is ajax populated (weird);
		$('.mfp-close').on('click', function() {
			$('#inspModal').magnificPopup('close');
		});
	}
}

export default attachHandlers;
